import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { ContentBox } from "../../components";
import { CheckMarkIcon } from "../../components/icons";
import * as styles from "./FormPreview.module.css";
import {
  ApplicationInformationRow,
  FormPreviewValidDataType,
  ReadOnlyFormId,
} from "./ReadOnlyForms";

export type FormPreviewProps = Readonly<{
  title: string;
  subtitle?: string;
  readOnlyForms: Map<ReadOnlyFormId, FormPreviewValidDataType>;
}>;

export const FormPreview = ({ title, subtitle, readOnlyForms }: FormPreviewProps) => (
  <ContentBox>
    <Row className={styles.applicationInformationHeaderRow}>
      <Column className={styles.applicationInformationIconColumn}>
        <CheckMarkIcon />
      </Column>
      <Column>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </Column>
    </Row>
    {[...readOnlyForms.keys()].map((formId, index) => {
      const dataForm = readOnlyForms.get(formId);
      return dataForm ? (
        <ApplicationInformationRow formId={formId} dataInForm={dataForm} key={index} />
      ) : null;
    })}
  </ContentBox>
);
